var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "footer",
    {
      staticClass: "small",
      class: { "dark-mode": _vm.darkMode },
      attrs: { id: "site-footer" },
      on: { click: _vm.footerEvent },
    },
    [
      !_vm.hideFooter
        ? _c(
            "div",
            { staticClass: "container" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-12 footer-links" }, [
                  _c(
                    "div",
                    { staticClass: "row footer-links__row" },
                    _vm._l(_vm.footerUrls, function (col) {
                      return col.condition && col.lists.length
                        ? _c(
                            "div",
                            {
                              staticClass: "col footer-links__col",
                              class: !col.lists.length
                                ? "shrunken-empty-column"
                                : "",
                            },
                            [
                              _c("h1", { staticClass: "text-h3" }, [
                                _vm._v(_vm._s(_vm.$t(col.title))),
                              ]),
                              _c(
                                "ul",
                                {
                                  staticClass: "list-unstyled",
                                  class: col.class,
                                },
                                _vm._l(col.lists, function (l) {
                                  return !l.hide
                                    ? _c("li", [
                                        !l.url
                                          ? _c(
                                              "span",
                                              _vm._b(
                                                { staticClass: "hover-link" },
                                                "span",
                                                l.attrs,
                                                false
                                              ),
                                              [
                                                _vm._v(_vm._s(_vm.$t(l.title))),
                                                l.extra
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "spr" },
                                                      [_vm._v(_vm._s(l.extra))]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : !_vm.checkLocation(l.url)
                                          ? _c(
                                              "a",
                                              _vm._b(
                                                { attrs: { href: l.url } },
                                                "a",
                                                l.attrs,
                                                false
                                              ),
                                              [
                                                _vm._v(_vm._s(_vm.$t(l.title))),
                                                l.extra
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "spr" },
                                                      [_vm._v(_vm._s(l.extra))]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.checkLocation(l.url)
                                          ? _c(
                                              "span",
                                              { staticClass: "active" },
                                              [
                                                _vm._v(_vm._s(_vm.$t(l.title))),
                                                l.extra
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "spr" },
                                                      [_vm._v(_vm._s(l.extra))]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                      ])
                                    : _vm._e()
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  ),
                ]),
              ]),
              _c("final-footer"),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }